import React from 'react';
import styled from 'styled-components';
import TopCoupons from '../../TopCoupons';

const TopCouponsTitle = () => {
  return (
    <Wrapper>
      <div className="container">
        <p className="categories-text ps-lg-5 ps-0">Top Coupons</p>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .container {
    width: 100%;
    max-width: 1410px;
    padding: 0 80px;
  }

  .categories-text {
    font-size: 20px;
    font-weight: bold;
    color: #ef4766;
    // margin-left: 60px;
    margin-top: 0;
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    .container {
      padding: 0 40px;
    }

    .categories-text {
      margin-left: 20px;
      font-size: 18px;
    }
  }

  @media (max-width: 480px) {
   padding-top:5px !important;
    .container {
      padding: 0 20px;
    }

    .categories-text {
      margin-left: 0;
      font-size: 16px;
    }
  }
`;

export default TopCouponsTitle;
